export default __webpack_public_path__ + "media/images/icons/eth-90f0d2e2bb7c127e5e4acbcbf8557451.png";